import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { reducerAvisos as postings } from '@panel/avisos';
import filters from '@panel/avisos/ducks/filter';
import publish from '@panel/avisos/ducks/publish';
import reservation from '@panel/avisos/ducks/reservation';
import cancelReservation from '@panel/avisos/ducks/cancelReservation';
import credits from '@panel/avisos/ducks/credits';
import modals from '@panel/avisos/ducks/modals';
import suspend from '@panel/avisos/ducks/suspend';
import archive from '@panel/avisos/ducks/archive';
import unreadLeadsMsg from '@panel/avisos/ducks/unreadLeadsMsg';
import responsibleUpdate from '@panel/avisos/ducks/responsibleUpdate';
import {
  step1Module1Reducer,
  step1Module2Reducer,
  step1Module4Reducer,
  multimediaReducer,
  step4Module1Reducer,
  step4Module2Reducer,
  step4Module3Reducer,
  savePostingReducer,
  step3Module1Reducer,
  seekerGuardReducer,
  stepperReducer,
  blockedUserReducer
} from '@panel/publicador';
import {
  stepperReducerProf,
  stepMainReducer,
  locationStepReducer,
  savePostingProfReducer,
  featuresReducer,
  priceStepReducer,
  multimediaStepReducer,
  stepDescriptionReducer,
  extraFeaturesReducer,
  formGuardReducer,
  publishReducer,
  previewReducer
} from '@panel/publicador-profesionales';
import { desempenoReducer, performanceReducer, appliedFilterReducer, rendimientosReducer } from '@panel/desempeno';
import { rendimientoReducer, appliedFiltersReducer, reputationReducer, scoreReducer } from '@panel/estadisticas';
import { plansInfoReducer } from '@panel/landing-zona-demand';
import { collaboratorsInfoReducer, contactDataInfoReducer } from '@panel/contactos-permisos';
import leadReducers from '@panel/leads/src/stores';
import usuariosReducers from '@panel/usuarios/src/store';
import micrositeReducer from '@panel/emprendimientos/src/store';
import { integrationsReducer, leadsIntegrationsReducer } from '@panel/integraciones';
import user from './ducks/user';
import userConfig from './ducks/userConfiguration';
import userPhoneCheck from './ducks/userPhoneCheck';
import userData from './ducks/userData';
import userSubscriptions from './ducks/userSubscriptions';
import userActivity from './ducks/userActivity';
import bumexFeatures from './ducks/bumexFeatures';
import contactValidation from './ducks/contactValidation';
import { apiService } from './middlewares';
import draftFull from './ducks/postingFull';
import reputationLevel from './ducks/reputationLevel';

export const browserHistory = createBrowserHistory({ basename: '/panel' });

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    filters,
    postings,
    user,
    draftFull,
    userConfig,
    userPhoneCheck,
    userData,
    userSubscriptions,
    userActivity,
    bumexFeatures,
    contactValidation,
    reputationLevel,
    publish,
    suspend,
    archive,
    unreadLeadsMsg,
    reservation,
    cancelReservation,
    credits,
    modals,
    responsibleUpdate,
    step1Module1: step1Module1Reducer,
    step1Module2: step1Module2Reducer,
    step1Module4: step1Module4Reducer,
    savePosting: savePostingReducer,
    step2Module1: multimediaReducer,
    step4Module3: step4Module3Reducer,
    step3Module1: step3Module1Reducer,
    step4Module1: step4Module1Reducer,
    step4Module2: step4Module2Reducer,
    seekerGuard: seekerGuardReducer,
    stepper: stepperReducer,
    stepperProf: stepperReducerProf,
    savePostingProf: savePostingProfReducer,
    stepMainProf: stepMainReducer,
    locationStep: locationStepReducer,
    multimediaStep: multimediaStepReducer,
    features: featuresReducer,
    extraFeatures: extraFeaturesReducer,
    formGuard: formGuardReducer,
    preview: previewReducer,
    stepDescriptionProf: stepDescriptionReducer,
    price: priceStepReducer,
    stepPublishProf: publishReducer,
    blockedUserReducer,
    desempeno: desempenoReducer,
    performance: performanceReducer,
    postingStatisticsFilter: appliedFilterReducer,
    postingStatisticsRendimiento: rendimientosReducer,
    lead: leadReducers,
    usuarios: usuariosReducers,
    rendimiento: rendimientoReducer,
    estadisticasFiltro: appliedFiltersReducer,
    reputation: reputationReducer,
    score: scoreReducer,
    microsite: micrositeReducer,
    plans: plansInfoReducer,
    collaboratorsInfo: collaboratorsInfoReducer,
    contactData: contactDataInfoReducer,
    integrations: combineReducers({
      xml: integrationsReducer,
      leads: leadsIntegrationsReducer
    })
  });

export default function configureStore(history, initialState) {
  const rootReducer = createRootReducer(history);
  const middlewares = [thunk, apiService, routerMiddleware(history)];
  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
}
